<template>
  <div class="reportListData">
    <div class="item" v-for="(item,index) in listData" :key="index">
      <div class="item_label">
        <span>{{item.exam_class}} ( {{item.insConfig.slice(0,item.insConfig.length-1)}} )</span>
        <span class="status Success">
          {{getExamStatus(item)}}
          <!-- <span
            v-if="(item.charge_mode == 1&&item.pay_status==0) || (item.charge_mode == 3&&item.pay_status==0)"
            class="status Danger"
          >(未支付)</span>-->
        </span>
      </div>
      <div class="item_content">
        <div>
          <span class="label">医院:</span>
          <span class="content">{{item.institution}}</span>
        </div>
        <div>
          <span class="label">流水号:</span>
          <span class="content">{{item.patient_num}}</span>
        </div>
        <div>
          <span class="label">姓名:</span>
          <span class="content">{{item.name}}</span>
        </div>
        <div>
          <span class="label">检查时间:</span>
          <span class="content">{{item.exam_datetime}}</span>
        </div>
        <div v-if="item.institution_id ==='06300007'">
          <span class="label">检查部位:</span>
          <span
            class="content"
            style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;flex: 1;"
          >{{item.exam_project}}</span>
        </div>
        <div v-if="item.config_number&&item.insConfig">
          <span class="label">{{item.insConfig}}:</span>
          <span class="content">{{item.config_number}}</span>
        </div>
      </div>
      <div class="item_time">
        <span>
          <button
            class="payButton"
            v-if="(item.charge_mode == 1&&item.pay_status==0) || (item.charge_mode == 3&&item.pay_status==0)"
            @click="pay(item)"
          >立即支付</button>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import Storage from "@/tools/storage";
export default {
  name: "reportResult",
  props: ["listData"],
  data() {
    return {};
  },
  methods: {
    openEmail(studyId) {
      this.$emit('emailShowFn', {'studyId':studyId,'value': true})
    },
    getExamStatus(item) {
      switch (item.exam_status) {
        case 1:
          return "已登记";
        case 2:
          return "检查中";
        case 3:
          return "报告中";
        case 7:
          return "报告审核中";
        case 8:
          return "报告已审核";
        case 9:
          return "报告已确认";
      }
      return item.exam_status;
    },
    checkReport(item) {
      console.log(item);
      // charge_mode 1:向患者收费 2：医院托管 3：医院代收
      // pay_status 0:未支付  1:已支付
      // film_price 价格（不能为0）
      // if (
      //   item.charge_mode == 1 &&
      //   item.pay_status == 0 &&
      //   item.film_price != 0
      // ) {
      //   alert('未支付数字影像服务费,无法查看报告')
      //   return
      // } else if (
      //   item.charge_mode == 3 &&
      //   item.pay_status == 0 &&
      //   item.film_price != 0
      // ) {
      //   alert('未支付数字影像服务费,请到医院缴费窗口缴费')
      //   return
      // } else {
      //   let params = { exam_id: item.exam_id }
      //   this.$emit('getPatientInfo', params)
      // }
      Storage.set("reportSee",item.report_see)
      Storage.set('examStatus',item.exam_status)
      if (item.exam_status == 9||(item.report_see==1&&item.exam_status != 9)) {

        let param = {
          exam_id: item.exam_id,
          institution_id: item.institution_id
        };
        this.$emit("getPatientInfo", param);
      } else {
        alert("报告未完成,无法查看报告");
        return;
      }
    },
    pay(item) {
      if (item.charge_mode == 1 && item.pay_status == 0) {
        let params = { id: item.exam_id };
        this.$emit("getWechatPay", params);
      } else if (item.charge_mode == 3 && item.pay_status == 0) {
        alert("未支付数字影像服务费,请到医院缴费窗口缴费");
      }
    },
    callReportPrint(item) {
      this.$emit("callReportPrint", item);
    }
  }
};
</script>
<style lang="scss" scoped>
.reportListData {
  width: 100%;
  display: inline-block;
  flex: 1;
  overflow-y: scroll;
  .item {
    height: 170px;
    border-radius: 5px;
    padding: 0 10px;
    box-sizing: border-box;
    background: #ffffff;
    margin-bottom: 20px;
    .item_label {
      height: 30px;
      border-bottom: 1px solid #cccccc;
      display: flex;
      align-items: center;
      color: #51cde4;
      justify-content: space-between;
      font-size: 16px;
      .status {
        font-size: 10px;
        .Danger {
          color: #f56c6c;
        }
      }
    }
    .item_content {
      height: 100px;
      display: flex;
      flex-direction: column;
      div {
        flex: 1;
        display: flex;
        align-items: center;
        font-size: 14px;
        text-align: left;
        .label {
          display: block;
          width: 80px;
          color: #999;
        }
        .content {
          color: #000;
        }
      }
    }
    .item_time {
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 12px;
      color: #000000;
      span {
        button {
          color: #ffffff;
          margin-right: 5px;
        }
        .payButton {
          width: 80px;
          padding: 5px 0;
          background-color: #f56c6c;
          border: 1px solid #f56c6c;
          border-radius: 3px;
        }
        .checkButton {
          width: 80px;
          padding: 5px 0;
          background-color: #409eff;
          border: 1px solid #409eff;
          border-radius: 3px;
        }
      }
    }
  }
}
</style>
